import React from "react";
import {
  Edit,
  SimpleForm,
  RefreshButton,
  CardActions,
  ListButton,
  TextInput,
  SelectArrayInput,
} from "react-admin";

const UserTitle = ({ record }) => {
  return (
    <span>
      User {record.name} - {record.email}
    </span>
  );
};

const PostEditActions = ({ basePath }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    <RefreshButton />
  </CardActions>
);

class EditUser extends React.Component {
  state = {
    password: "",
  };

  handleChangeInput = (ev) => {
    this.setPassword(ev.target.value);
  };

  setPassword = (password) => {
    this.setState({ password });
  };

  render() {
    return (
      <Edit actions={<PostEditActions />} title={<UserTitle />} {...this.props}>
        <SimpleForm>
          <TextInput source="email" />
          <TextInput
            source="password"
            defaultValue={this.state.password}
            onChange={this.handleChangeInput}
          />
          <SelectArrayInput
            label="Roles"
            source="roles"
            choices={[
              { id: "ADMIN", name: "Admin" },
              { id: "MANAGER", name: "Manager" },
              { id: "DRIVER", name: "Driver" },
            ]}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export default EditUser;



// WEBPACK FOOTER //
// ./src/users/Edit.js